import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupCore } from '../../../components';
import { Content as LoginContent } from '../../../pages/login/components';
import { Content as RegisterContent } from '../../../pages/register/components';
import { Content as ForgotContent } from '../../../pages/forgot-password/components';
import { setShowAuth } from '../slice';

const AuthPopup = () => {
  const dispatch = useDispatch()
  const { popupContent } = useSelector(state => state.account)

  return (
    <PopupCore
      customWidth="w-full"
      relative
      onClose={() => setShowAuth(false)}
    >
      {
        popupContent === 'login' &&
        <LoginContent
          embed
          onClose={() => dispatch(setShowAuth(false))}
          noRedirect
        />
      }
      {
        popupContent === 'register' &&
        <RegisterContent
          embed
          onClose={() => dispatch(setShowAuth(false))}
          noRedirect
        />
      }
      {
        popupContent === 'forgot' &&
        <ForgotContent
          embed
          onClose={() => dispatch(setShowAuth(false))}
          noRedirect
        />
      }
    </PopupCore>
  )
}

export default AuthPopup
